import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import BannerComponent from "../../Components/BannerComponent";
import {  harsh, pattern4 } from "../../assets/assets";
import styled from "styled-components";
import "./index.css";
import useScreenSize from "../../hooks/useScreenSize";
const StyledImage = styled.div`
  max-width: 350px;
  height:400px;
  border-radius:5px;
  position:relative;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }
`;

const AboutUs = () => {
    const { isLessThanMd } = useScreenSize();
    return (
        <Box
            className=""
            sx={{
                margin: isLessThanMd ? "0px 20px 50px 20px" : "0px 0px 50px 0px",
            }}
        >
            <Box className="container">
                <BannerComponent
                    sectionTitle="About us"
                    title="Making finances easier"
                    body="We offer accessible financial services to all communities at their doorstep."
                />
            </Box>
            <Box
                className="section-divide container"
            >
                <Grid2 container spacing={1}>
                    <Grid2 size={{ lg: 7 }} sx={{ border: '0px solid red' }}>
                        <Box className="section-header-dark" sx={{padding:0}}>
                            <Typography variant="h2" className="sec-tittle-color" sx={{margin:'0 !important'}} >
                                What We Offer
                            </Typography>
                        </Box>

                        <section className="about-us-section">
                            <h2>WHO WE ARE?</h2>
                            <p>
                                Tresor Micro Federation (TMF) was established in 2023 with the goal
                                of serving the economically weaker sections of society, helping them
                                integrate into the mainstream by providing need-based financial
                                services directly at their doorstep.
                            </p>
                            <p>
                                The focus has been clear: to reach areas where formal financial
                                institutions face challenges in establishing a presence. Our aim is
                                to foster entrepreneurship where traditional banking systems have
                                limited access.
                            </p>
                            <p>
                                We achieve this by offering a holistic range of financial and
                                non-financial products, with micro-credit being our primary focus.
                                Over time, Tresor Micro has continued to innovate its product
                                offerings and delivery mechanisms, ensuring that micro-credit
                                remains relevant and accessible for its clients.
                            </p>
                            <p>
                                Our mission is to bridge the gap between economic opportunity and
                                outcome, offering products tailored to meet the specific life-cycle
                                needs of our customers. Our vision is to become a next-generation
                                microfinance entity, providing differential financial solutions
                                through constant technological innovation, to bring the unbanked
                                into the financial fold.
                            </p>
                        </section>
                    </Grid2>
                    <Grid2 size={{ lg: 5 }} sx={{ width: '100%', position: '', border: '0px solid red', alignItems: 'baseline', display: 'flex', placeContent: 'center' }}>
                        <StyledImage className="about-us-img-container">
                            <img
                                className="img"
                                src={harsh}
                                alt="Headshot"
                            />
                            <img
                                className="img-pattern"
                                src={pattern4}
                            />
                        </StyledImage>
                    </Grid2>
                </Grid2>
            </Box>
            <Box className="container">
                <section className="about-us-section">
                    <h2>OBJECTIVES</h2>
                    <p>
                        At Tresor Micro, we encourage entrepreneurship among rural women by
                        providing them with differential financial solutions that allow them
                        to invest in the growth of their businesses. Our microloans, one of
                        the lowest interest rates in the country, are offered individually
                        or within groups of 5-15 women, with each group member acting as a
                        credit guarantor for the others.
                    </p>
                    <p>
                        Our commitment to financial inclusion is exemplified by our 100%
                        cashless disbursement model. From day one, loans are disbursed
                        directly to customers’ bank accounts. For those who do not have a
                        bank account, we assist them in opening one, allowing customers not
                        only to gain confidence in banking but also to earn interest on
                        their savings.
                    </p>
                    <p>Our specific objectives are:</p>
                    <ul>
                        <li>To provide financial assistance for economic empowerment.</li>
                        <li>
                            To offer tailor-made, need-based products to cater to every
                            life-cycle need of our clients.
                        </li>
                        <li>
                            To prioritize women and actively involve them in production
                            activities through Self-Help Groups (SHGs) and access to finance,
                            thereby creating opportunities for additional income.
                        </li>
                        <li>
                            To provide technical assistance, enabling the poor to become
                            self-sufficient by accumulating and creating their own capital
                            through savings from increased income.
                        </li>
                    </ul>
                </section>

                <section className="about-us-section">
                    <h2>SOCIAL OBJECTIVES</h2>
                    <p>
                        Tresor Micro has a strong social mission aimed at improving the
                        lives of marginalized communities:
                    </p>
                    <ul>
                        <li>
                            To provide microloans to households identified as Below Poverty
                            Line (BPL).
                        </li>
                        <li>
                            To cater microfinance services to special categories of
                            individuals, including widows, transgender persons, and those with
                            disabilities.
                        </li>
                        <li>
                            To provide financial assistance to Scheduled Castes (SC),
                            Scheduled Tribes (ST), and other minority or backward classes.
                        </li>
                    </ul>
                </section>

                <section className="about-us-section">
                    <h2>ENVIRONMENTAL OBJECTIVES</h2>
                    <p>
                        As part of our commitment to sustainability, Tresor Micro works to
                        minimize the environmental impact of its lending activities. Our
                        environmental objectives include:
                    </p>
                    <ul>
                        <li>
                            Making constant efforts to improve internal environmental
                            management standards and reduce carbon footprints.
                        </li>
                        <li>
                            Offering sustainable and green products through careful product
                            design.
                        </li>
                    </ul>
                </section>
            </Box>
        </Box>
    );
};

export default AboutUs;
